var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4349",
    "data-name": "Rectangle 4349",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7855",
    "data-name": "Group 7855"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(7 -1)",
    fill: "#f5f5f5",
    stroke: "#f5f5f5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25315",
    "data-name": "Path 25315",
    d: "M23,13H7a1,1,0,0,0,0,2h5.95v5l-2.4,7.7a1,1,0,0,0,.65,1.25h.3a1,1,0,0,0,.95-.7L14.9,20.5h.2l2.45,7.8a1,1,0,0,0,.95.7h.3a1,1,0,0,0,.65-1.25L17.05,20V15H23a1,1,0,0,0,0-2Z",
    transform: "translate(-6 -8)",
    fill: "#f5f5f5",
    stroke: "#f5f5f5",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIconSelected);
export default __webpack_public_path__ + "static/media/ManIconSelected.1ac04513fd3b25c49dba19b77c6a4807.svg";
export { ForwardRef as ReactComponent };